<template>
  <div class="elt" v-if="exLiveList.length">
    <div class="elt-title">
      <div class="title_dian">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="txt">Live</div>
    </div>
    <div class="elt-content">
      <template >
        <div class="elt-item" v-for="(item, index) in exLiveList" :key="'elt-' + index" @click="LinkAct(item)">
          <div class="elti-img">
            <img
              v-if="item.liveBanners"
              :src="item.liveBanners"
              v-load="'oLiveCover'"
            />
            <img v-else src="@/assets/img/empty.png" >
          </div>
          <div class="elti-layout">
            <div class="brand-box">
              <div class="brand dot" v-if="item.liveStateIndex === 1">Live</div>
              <div class="brand s-blue" v-else-if="item.liveStateIndex===2">Preparing</div>
              <div class="brand s-end" v-else>Finished</div>
            </div>
            <div class="txt van-ellipsis">{{item.titleEn || item.title}}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import {mapGetters, mapActions} from "vuex";
export default {
  name: "ex-live-tool",
  data() {
    return {
      exLiveList:[],
      queryActivityExhibitor:{},
      page:1,
      size:30,
    };
  },
  computed:{
    ...mapGetters({
      exonId:"getExhibitionId"
    }),
    exhibitionId() {
      return this.$route.params.id||this.exonId;
    },
  },
  created(){
    this.getExLiveTool();
  },
  methods:{
    ...mapActions({
      LinkAct:"linkTo/LinkAct"
    }),
    getExLiveTool(){
      const query = gql`
        query queryActivityExhibitor($query:QueryInput!){
          queryActivityExhibitor(query:$query){
            hasNextPage
            pageIndex
            items{
              acvitityType
              hasLive
              liveAuditState
              id
              title
              titleEn
              banners
              liveStateIndex    #活动进行状态 1：进行中、2：未开始：3：已结束
              liveBanners   #直播宣传图 
            }
          }
        }
      `;
      let where={
        "equal":{
          "n":'exhibitionId',
          "v":this.exhibitionId
        },
        "GreaterThan":{
          "n":'liveTopic',
          "v":0
        }
      }
      let order=[
        {
          'n':'liveStateIndex',
          "v":1
        },
        {
          'n':'LiveTopic',
          'v':0
        },
        {
          'n':'LiveTopicIndex',
          'v':0
        },
        {
          'n':'startTime',
          'v':1
        },
        {
          'n':'ViewCount',
          'v':0
        },
        {
          'n':'CreateAt',
          'v':0
        }
      ]
      let opt={
        page:this.page,
        size:this.size,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      console.log(opt)
      this.$apollo.addSmartQuery("queryActivityExhibitor", {
        query: query,
        variables: {
          query:opt
        },
        fetchPolicy: "network-only", //清理缓存
        result(res) {
          console.log('请求回来了exLive',res)
          let data = JSON.parse(JSON.stringify(res.data.queryActivityExhibitor));
          // let data=res.data.giveExInfo;
          if (data) {
            this.exLiveList=data.items;
          }
          this.$emit('requestOk','exLiveIsOk')    //专题直播获取完成
        },
        error(err) {},
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.elt {
  padding: 0 15px;
  // background: #fff;
  margin-bottom: 15px;
  &-title {
    padding: 0.25rem 0 ;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #333;
    .title_dian{
      display: flex;
      justify-content: space-between;
      width: 0.06rem;
      height: 0.24rem;
      flex-direction: column;
      margin-right: 0.1rem;
      span{
        width: 0.06rem;
        height: 0.06rem;
        display: block;
        border-radius: 0.02rem;
        background-image: linear-gradient(90deg, #ff4b1b 0%, #fe781d 100%), linear-gradient(#108ee9,#108ee9);
        &:nth-child(1){
          opacity: 0.5;
        }
        &:nth-child(2){
          opacity: 0.75;
        }
      }
    }
    img {
      width: 13px;
    }
    .txt {
      // padding: 0 7px;
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  &-content {
    overflow-x: scroll;
    overflow-y: hidden;
    padding-bottom: 15px;
    white-space: nowrap;
    &::-webkit-scrollbar {
      display: none;
    }
    .elti {
      &-img {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          // object-fit: cover;
          margin: auto;
        }
      }
      &-layout {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        .brand-box {
          margin-top: 0.1rem;
          margin-left:0.1rem;
          // width: 0.88rem;
          // height: 0.3rem;  
          .brand {
            // width: 0.88rem;
            padding: 0 0.1rem;  
            height: 0.3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
              linear-gradient(#000, #000);
            background-blend-mode: normal, normal;
            border-radius:0.05rem;
            color: #fff;
            font-size: 0.18rem;
            vertical-align: middle;
            &.dot {
              &::before {
                content: "";
                display:block;
                width: 0.12rem;
                height: 0.12rem;
                border-radius: 50%;
                background-color: #fff;
                margin-right: 0.06rem;
              }
            }
            &.s-blue {
              background-image: linear-gradient(90deg, #56ccf2 0%, #2f80ed 100%),
                linear-gradient(#000, #000);
            }
            &.s-end{
            //   background-image: linear-gradient(90deg, 
            // #ffc659 0%, 
            // #ffa751 100%), 
            //   linear-gradient(
            // #000, 
            // #000);
              background: #bfbfbf;
            }
          }
        }
        .txt {
          font-size: 0.2rem;
          color: #fff;
          height: 0.38rem;
          line-height:0.38rem;
          width: 100%;
          padding: 0 0.1rem;
          background-image: linear-gradient(
            0deg,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0.1) 100%,
            #805e00 100%,
            #ffbc00 100%,
            #805e00 100%,
            #000 100%
          );
        }
      }
    }
  }
  &-item {
    display: inline-block;
    width: 1.9rem;
    height: 2.53rem;
    border-radius: 3px;
    border: solid 1px #e6e6e6;
    margin-right: 5px;
    position: relative;
    border-radius: 0.1rem;
    overflow: hidden;
  }
}
</style>